import DictUtil from '@/utils/dict-utils'
import Dict from '@/utils/dict-utils'

// 增值服务产品分类编号
export const valueAddedCategoryCodeDict = new DictUtil({
  VIP: { label: '标前狗', value: 'vip' }
})

// 增值服务支付状态
export const valueAddedPayStatusDict = new DictUtil({
  WAIT_PAY: { label: '待支付', value: 0 },
  PAY_SUCCESS: { label: '支付成功', value: 1 }
})

// 增值服务产品期限单位
export const valueAddedDurationUnitDict = new DictUtil({
  HOUR: { label: '小时', value: 1, unitLabel: '小时' },
  DAY: { label: '天', value: 2, unitLabel: '天' },
  WEEK: { label: '周', value: 3, unitLabel: '周' },
  MONTH: { label: '月', value: 4, unitLabel: '个月' },
  YEAR: { label: '年', value: 5, unitLabel: '年' }
})

// 增值服务产品优惠类型
export const valueAddedPreferentialTypeDict = new DictUtil({
  DISCOUNT: { label: '折扣', value: 1 },
  REDUCE: { label: '减免', value: 2 }
})

// 增值服务产品生效类型
export const valueAddedEffectTypeDict = new DictUtil({
  NONE: { label: '无', value: 0 },
  TIME: { label: '时间', value: 1 },
  COUNT: { label: '次数', value: 2 }
})

// 增值服务产品类型
export const valueAddedTypeDict = new DictUtil({
  VIP: { label: '标前狗', value: 1 },
  SUBSCRIPTION: { label: '标讯订阅', value: 2 },
  PREVIEW: { label: '标书预览', value: 3 },
  CERTIFICATE: { label: '数字证书', value: 4 }
})

// 标书预览服务异常code
export const bidFilePreviewErrorCodeDict = new DictUtil({
  AVS_NOT_PURCHASE: { label: '未购买该增值服务', value: '41003' },
  BID_FILE_NOT_EXIT: { label: '当前项目暂无标书文件', value: '41004' },
  SIGN_UP_END: { label: '当前项目已截止报名', value: '41005' },
  PURCHASE_AVS_FAIL: { label: '获取增值服务信息异常', value: '41006' }
})

// 增值服务产品编号
export const valueAddedProductCodeDict = new DictUtil({
  MARK_SUBSCRIBE: {
    label: '标讯订阅',
    value: 'mark_subscribe',
    effectType: valueAddedEffectTypeDict.TIME.value,
    unit: '天',
    homeSerch: true
  },
  BID_FILE_PREVIEW: {
    label: '标书预览',
    value: 'bid_file_preview',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '次',
    homeSerch: true
  },
  REGULAR_VIP: {
    label: '基础标前狗会员',
    value: 'regular_vip',
    alias: 'regular',
    bannerAlias: 'PORTAL_VIP_BASIC_PRIVILEGE',
    servicePhone: '',
    unitPrice: 300, // 单价
    packageName: '基础会员',
    salesBanner: '助力迅速投标',
    effectType: valueAddedEffectTypeDict.TIME.value
  },
  ADVANCED_VIP: {
    label: '高级标前狗会员',
    value: 'advanced_vip',
    alias: 'advanced',
    bannerAlias: 'PORTAL_VIP_PREMIUM_PRIVILEGE',
    servicePhone: '0791-83888190',
    unitPrice: 3600, // 单价
    packageName: '高级会员',
    salesBanner: '超值推荐，全方位护航投标',
    effectType: valueAddedEffectTypeDict.TIME.value
  },
  DIAMOND_VIP: {
    label: '钻石标前狗会员',
    value: 'diamond_vip',
    alias: 'diamond',
    bannerAlias: 'PORTAL_VIP_DIAMOND_PRIVILEGE',
    servicePhone: '0791-83888190',
    unitPrice: 5800, // 单价
    packageName: '钻石会员',
    salesBanner: '更多优选权益，纵享商机',
    effectType: valueAddedEffectTypeDict.TIME.value
  },
  DIGITAL_CERTIFICATE_VOUCHER: {
    label: '数字证书抵用券',
    value: 'digital_certificate_voucher',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '张',
    homeSerch: true
  },
  COMPANY_PORTRAIT: {
    label: '企业画像',
    value: 'company_portrait',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '个',
    homeSerch: true
  },
  NOTICE_EXPORT: {
    label: '数据定制导出',
    value: 'notice_export',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '条',
    homeSerch: true
  },
  // 后台不存在该产品
  FOLLOW_COMPANY: {
    label: '企业关注',
    value: 'follow_company',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '个',
    hide: true
  },
  // 后台不存在该产品
  FOLLOW_PROJECT: {
    label: '项目关注',
    value: 'follow_project',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '个',
    hide: true
  },
  ESIGN_VOUCHER: {
    label: '在线签章抵扣券',
    value: 'esign_voucher',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '张',
    hide: true,
    homeSerch: true
  }
})

// 公告来源
export const noticeResourceDict = new DictUtil({
  JCZH: { label: '精彩纵横云采购', value: 1 },
  PUBLIC_SOURCE: { label: '全国公共资源交易网', value: 2 },
  PUBLIC_SERVICE: { label: '中国招标投标公共服务平台', value: 3 },
  PUBLIC_JX: { label: '江西省公共资源交易中心', value: 4 },
  PUBLIC_GX: { label: '广西公共资源交易平台', value: 5 },
  PUBLIC_GZ: { label: '广州公共资源交易中心', value: 6 }
})

// 公告类型
export const biddogNoticeTypeDict = new DictUtil({
  PURCHASE_INTENTION: {
    label: '采购意向公告',
    value: 6,
    type: 'warning',
    dynamicLabel: '采购意向'
  },
  PURCHASE: {
    label: '采购公告',
    value: 3,
    type: 'primary',
    dynamicLabel: '发布'
  },
  CHANGE: {
    label: '变更公告',
    value: 4,
    type: 'warning',
    dynamicLabel: '变更'
  },
  CANDIDATE: {
    label: '候选公告',
    value: 1,
    type: 'primary',
    dynamicLabel: '候选'
  },
  MAKE_A_DEAL: {
    label: '成交公告',
    value: 2,
    type: 'success',
    dynamicLabel: '成交'
  },
  FLOW_MARK: {
    label: '流标公告',
    value: 5,
    type: 'info',
    dynamicLabel: '流标'
  },
  PURCHASE_CONTRACT: {
    label: '采购合同',
    value: 7,
    type: 'success',
    dynamicLabel: '合同'
  },
  OTHER: {
    label: '其他公告',
    value: -1,
    type: 'primary',
    dynamicLabel: '其他'
  }
})

// 标前狗--招标方式字典
export const biddogBidMethodDict = new Dict({
  PUBLIC_BIDDING: { label: '公开招标', value: 1 },
  INVITE_BIDDING: { label: '邀请招标', value: 2 },
  COMPETITIVE_CONSULT: { label: '竞争性磋商', value: 3 },
  COMPETITIVE_NEGOTIATION: { label: '竞争性谈判', value: 4 },
  INQUIRY: { label: '询价', value: 5 },
  SINGLE_SOURCE: { label: '单一来源', value: 6 },
  INQUIRY_PURCHASE: { label: '询比', value: 7 },
  COMPETE_PURCHASE: { label: '竞价', value: 8 },
  NEGOTIATION_PURCHASE: { label: '谈判', value: 9 },
  OTHER: { label: '其他', value: -1 }
})

// 数据定制导出状态
export const customDataExportStatusDict = new DictUtil({
  PENDING: { label: '待支付', value: 1, status: 'info' },
  EXPORTING: { label: '导出中', value: 2, status: 'primary' },
  SUCCESS: { label: '已导出', value: 3, status: 'success' },
  FAIL: { label: '导出失败', value: 4, status: 'danger' }
})
